import { render, staticRenderFns } from "./template-name-step.vue?vue&type=template&id=0b623487"
import script from "./template-name-step.vue?vue&type=script&lang=js"
export * from "./template-name-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports